<template>
  <div class="bg-white relative pb-40 border-t px-14 border-gray-200">
    <!-- SIMPILE BLOCK SECTION -->
    <div class="flex space-x-16 pt-10" v-if="section.blocks">
      <div class="flex-1">
        <div class="text-3xl font-bold text-gray-900 tracking-tight">
          {{ section.title }}
        </div>
        <div class="mt-2 text-gray-700 leading-7 tracking-wide">
          <div class="section-desc" v-html="section.desc"></div>
        </div>
      </div>
      <div class="flex-1 pt-10">
        <div
          v-for="block in section.blocks"
          v-bind:key="block.title + block.type"
          class="mb-8"
        >
          <CodeBlock
            v-if="block.type === 'code'"
            :lang="block.lang"
            :code="block.code"
            :title="block.title"
          />
          <RequestCode v-if="block.type === 'request'" :request="block" />
        </div>
      </div>
    </div>

    <!-- API SECTION -->
    <div v-if="section.api" class="pt-10">
      <div class="flex space-x-16">
        <div class="flex-1">
          <div class="text-3xl font-bold text-gray-900 tracking-tight">
            {{ section.title }}
          </div>
          <div class="mt-2 text-gray-700 leading-7 tracking-wide">
            <div class="section-desc" v-html="section.desc"></div>
          </div>
        </div>
        <div class="flex-1" v-if="section.api.requests">
          <!-- <div class="text-xl font-bold text-gray-900 tracking-tight	">
            Endpoints
          </div>
          <div v-for="request in (section.api.requests)" v-bind:key="request.url" class="">
            <div class="flex space-x-2 text-base py-1 pl-3">

            </div>
          </div> -->
        </div>
      </div>

      <div class="flex-1">
        <div
          v-for="request in section.api.requests"
          v-bind:key="request.url"
          class="mt-32"
          :id="(request.request || {}).url"
          style="scroll-margin-top: 4rem"
        >
          <div v-if="request.type === 'info'" class="flex">
            <div class="flex-1">
              <div
                class="text-xl font-bold text-gray-900 tracking-tight flex space-x-4 items-center"
              >
                <div class="flex-1">
                  {{ request.title }}
                </div>
              </div>
              <div class="mt-2 text-gray-700 leading-7 tracking-wide">
                <div class="section-desc" v-html="request.desc"></div>
              </div>
            </div>
            <div class="flex-1"></div>
          </div>
          <div class="flex space-x-16 pb-12" v-else>
            <div class="flex-1">
              <div
                class="text-xl font-bold text-gray-900 tracking-tight flex space-x-4 items-center"
              >
                <div class="flex-1">
                  {{ request.title }}
                </div>
                <div class="flex space-x-2 text-base px-2 py-1">
                  <div
                    class="tech font-bold text-green-600"
                    v-if="request.request.method === 'GET'"
                  >
                    GET
                  </div>
                  <div
                    class="tech font-bold text-yellow-600"
                    v-if="request.request.method === 'POST'"
                  >
                    POST
                  </div>
                  <c>{{ request.request.url.split(".com")[1] }}</c>
                </div>
              </div>
              <div class="mt-2 text-gray-700 leading-7 tracking-wide">
                <div class="section-desc" v-html="request.desc"></div>
              </div>
            </div>
            <div class="flex-1"></div>
          </div>
          <div class="flex space-x-16" v-if="request.type !== 'info'">
            <div class="flex-1">
              <div class="flex-1" v-if="request.request.parameters">
                <div
                  class="border-b border-gray-300 text-gray-700 pb-2 text-lg"
                >
                  {{ request.request.body ? "Body" : "Parameters" }}
                </div>
                <div
                  v-for="parameter in request.request.parameters || []"
                  v-bind:key="parameter.name"
                >
                  <CodeAttribute :attribute="parameter" />
                </div>
              </div>
              <div
                class="border-b border-gray-300 pt-16 text-gray-700 pb-2 text-lg"
                v-if="request.response"
              >
                Response
              </div>
              <div
                v-for="attribute in request.attributes || []"
                v-bind:key="attribute.name"
              >
                <CodeAttribute :attribute="attribute" />
              </div>
            </div>

            <div class="flex-1 flex flex-col space-y-8 overflow-x-scroll">
              <CodeBlock
                lang="json"
                :code="request.request.body"
                title="Request Body"
                v-if="request.request.body"
              />
              <RequestCode :request="request" v-if="request.response" />
              <CodeBlock
                v-if="request.response"
                lang="json"
                :code="request.response"
                title="Response"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CodeAttribute from "./CodeAttribute.vue";
import CodeBlock from "./CodeBlock.vue";
import RequestCode from "./RequestCode.vue";

export default {
  components: { CodeBlock, RequestCode, CodeAttribute },
  name: "MainSection",
  data: () => {
    return {
      code: JSON.stringify({ hey: 123, this: null, done: "deal" }, null, 2),
    };
  },
  props: ["section"],
  mounted() {},
  methods: {},
};
</script>
